module.exports = __webpack_public_path__ + "img/title-screen.4bed010c.png";